(() => {
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  const selectors = '.sl-finder__heading,.sl-quality__heading,.sl-quality__item,.sl-standard__copy,.sl-social-proof h2,.sl-home-blog__header,.sl-home-faq__header,.sl-home-blog__card,.lmf img,.lmk img,.lmd img,.lmu img,.sl-calm-copy,.sl-calm-picture,.sl-calm-card-image';
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const el = entry.target;
      observer.unobserve(el);
      // Start outside the viewport; a fast scroll must never move visible content.
      if (preference.matches || entry.boundingClientRect.top < innerHeight) continue;
      if (el.tagName === 'IMG' && (!el.complete || !el.naturalWidth)) continue;
      const animation = el.animate([{ translate: '0 16px' }, { translate: '0 0' }], {
        duration: 600, easing: 'cubic-bezier(.22,.61,.36,1)'
      });
      running.add(animation);
      animation.finished.catch(() => {}).finally(() => running.delete(animation));
    }
  }, { rootMargin: '0px 0px 80px 0px', threshold: 0 });
  function init(root = document) {
    if (preference.matches) return;
    root.querySelectorAll(selectors).forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      const rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height || rect.top <= innerHeight + 80) return;
      if (el.tagName === 'IMG' && Math.max(rect.width, rect.height) < 100) return;
      if (el.closest('.swiper,.swiper-container,.slick-slider,.section-main-product')) return;
      observer.observe(el);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  preference.addEventListener('change', () => {
    if (!preference.matches) return;
    observer.disconnect();
    running.forEach(animation => animation.cancel());
    running.clear();
  });
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    running.forEach(animation => animation.cancel());
  });
})();
